import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var paymentMethodJcbIcon = /*#__PURE__*/React.createElement("svg", {
  height: "35",
  width: "56",
  viewBox: "0 0 56 35",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "-.356%",
  x2: "99.642%",
  y1: "50.183%",
  y2: "50.183%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#007B40"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#55B330"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: ".708%",
  x2: "100.208%",
  y1: "50.182%",
  y2: "50.182%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#1D2970"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#006DBA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: ".195%",
  x2: "100.097%",
  y1: "51.28%",
  y2: "51.28%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#6E2B2F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E30138"
}))), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h56v35H0z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56 0v35H0V0h56Zm-1 1H1v33h54V1Z",
  fill: "#DADADA",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.459 15.759c1.095.023 2.197-.049 3.289.037 1.105.206 1.371 1.88.39 2.428-.67.36-1.467.134-2.193.198H30.46v-2.663Zm3.922-3.015c.244.86-.585 1.631-1.412 1.513h-2.51c.017-.81-.035-1.69.025-2.458 1.006.029 2.02-.057 3.02.045.43.108.79.461.877.9ZM40.423.001c.046 1.641.006 3.369.02 5.043-.003 6.808.007 13.615-.005 20.423-.044 2.55-2.305 4.767-4.839 4.818-2.536.01-5.073.002-7.609.005V19.998c2.764-.014 5.529.029 8.291-.022 1.282-.08 2.685-.926 2.745-2.336.15-1.416-1.185-2.396-2.452-2.55-.488-.013-.473-.143 0-.199 1.208-.261 2.158-1.513 1.802-2.766-.303-1.318-1.76-1.829-2.972-1.826-2.47-.017-4.942-.002-7.414-.007.017-1.921-.033-3.845.027-5.765.196-2.505 2.514-4.57 5.012-4.526h7.394Z",
  fill: "url(#a)",
  transform: "translate(7.465 2.354)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.066 4.787C.129 2.24 2.399.042 4.93.005 7.457-.003 9.983.003 12.51 0c-.007 8.522.014 17.046-.01 25.568-.098 2.516-2.344 4.673-4.846 4.717-2.532.01-5.063.001-7.595.004V19.652c2.459.58 5.038.828 7.546.442 1.5-.241 3.14-.977 3.648-2.533.374-1.33.163-2.73.219-4.097v-3.171H7.13c-.02 2.097.04 4.199-.031 6.294-.117 1.288-1.392 2.106-2.607 2.062-1.506.016-4.491-1.091-4.491-1.091-.008-3.93.043-8.853.065-12.77Z",
  fill: "url(#b)",
  transform: "translate(7.465 2.354)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.13 11.572c-.229.048-.046-.779-.105-1.092.015-1.984-.033-3.969.027-5.95.195-2.517 2.53-4.588 5.039-4.529h7.386c-.007 8.522.013 17.046-.01 25.568-.098 2.516-2.344 4.673-4.847 4.717-2.531.01-5.063.002-7.595.004V18.634c1.729 1.42 4.079 1.64 6.233 1.644 1.624 0 3.238-.251 4.815-.626v-2.135c-1.777.886-3.866 1.448-5.836.94-1.375-.343-2.372-1.67-2.35-3.09-.16-1.474.706-3.031 2.155-3.47 1.8-.563 3.761-.132 5.448.6.361.19.728.424.583-.18V10.64c-2.82-.671-5.823-.919-8.658-.188-.82.231-1.619.582-2.286 1.121Z",
  fill: "url(#c)",
  transform: "translate(7.465 2.354)"
}))));

export { paymentMethodJcbIcon as default };
//# sourceMappingURL=paymentMethodJcbIcon.js.map
